/* eslint-disable import/prefer-default-export */
import colors from 'styles/colors';

export const defaultIconColor = colors.fleetDarkGray;
